import { openConfirmModal, openModal } from '@mantine/modals';
import { showNotification } from '@mantine/notifications';
import i18next from 'i18next';
import Cookies from 'js-cookie';

import { cookieConfig, KEY_MYGPT_REFRESH_TOKEN, KEY_MYGPT_TOKEN, KEY_MYGPT_TOKEN_EXPIRESIN } from '../constant';
import { ERROR_DETAIL, ErrorDetailType } from '../constant/error';
import { baseHost, baseUrl, isAdmin } from './index';

export const translateError = (errMsg: string, errorInfo?: ErrorDetailType): string => {
  let knownError = null;
  const errorDetail = errorInfo || ERROR_DETAIL;
  for (const key in errorDetail) {
    if (!errMsg.startsWith(key)) continue;
    const errorValue = errorDetail[key];
    if (typeof errorValue === 'string') {
      knownError = i18next.t(errorValue);
      break;
    }
    if (typeof errorValue === 'object') {
      const nextKey = errMsg.substring(key.length, errMsg.length);
      knownError = translateError(nextKey, errorValue);
      break;
    }
  }
  return knownError || errMsg;
};

/**
 * 错误弹窗提示
 */
export const errorModal = (errMsg: string) => {
  showNotification({
    message: errMsg || i18next.t('errors.unknown.description').toString(),
    color: 'red',
  });
};

/**
 * 超出套餐限制弹窗提示
 */
export const limitErrorModal = () => {
  openConfirmModal({
    centered: true,
    title: i18next.t('pricing.limit_plan').toString(),
    children: i18next.t('pricing.limit_desc').toString(),
    labels: {
      confirm: i18next.t('pricing.upgrade_button').toString(),
      cancel: i18next.t('pricing.contact_us').toString(),
    },
    onCancel: () => {
      window.open(`${baseHost}/support.html`, '_blank');
    },
    onConfirm: () => {
      window.open(`${baseHost}/pricing`, '_blank');
    },
  });
};

export const loginExpired = () => {
  Cookies.remove(KEY_MYGPT_TOKEN(), { domain: cookieConfig.COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_REFRESH_TOKEN(), { domain: cookieConfig.COOKIE_DOMAIN });
  Cookies.remove(KEY_MYGPT_TOKEN_EXPIRESIN(), { domain: cookieConfig.COOKIE_DOMAIN });

  if (isAdmin) {
    // admin
    const redirectUrl = window.location.href;

    const urlParam = redirectUrl ? `&state=${btoa(encodeURI(redirectUrl))}` : '';
    let loginUrl = baseUrl + '/login?response_type=code' + urlParam;

    // redirect_uri： 由后端环境控制是否使用该参数跳到本地登录页
    loginUrl += `&redirect_uri=${encodeURI(window.location.origin + '/auth/login')}`;

    openModal({
      centered: true,
      withCloseButton: false,
      closeOnClickOutside: false,
      radius: 'md',
      children: 'loading ...',
    });
    window.location.href = loginUrl;
  } else {
    // 官网
    if (window.location.href !== window.location.origin + '/') {
      window.location.href = baseUrl + `/login?response_type=code&state=${btoa(encodeURI(window.location.href))}`;
    }
  }
};
